import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { LIVE_ACCOUNT_URL } from "../../lib/api";
import { fadeVariants } from "../../lib/motion";

const PLATFORM_IMG =
    "https://static.prod-images.emergentagent.com/jobs/51f38290-0410-404e-b160-085423ca1b2a/images/ce24a215838e676ed65d7b39ebe604e1af8611be7fb37b371eca19451cafa5bf.png";

const copyEnter = fadeVariants({ y: 20, duration: 0.6 });
const imageEnter = fadeVariants({ x: 30, duration: 0.8, delay: 0.15 });

function PlatformHeroCopy() {
    return (
        <motion.div
            variants={copyEnter}
            initial="hidden"
            animate="visible"
            className="lg:col-span-7"
        >
            <p className="overline mb-4">MetaTrader 5</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.05]">
                The platform institutions use.
                <br />
                <span className="text-[#A6E3DC]">
                    Tuned for retail traders.
                </span>
            </h1>
            <p className="text-slate-300 text-lg mt-6 max-w-xl leading-relaxed">
                MT5 powers every XPO Markets account. Industry-standard
                charting, native algorithmic trading, and lightning execution —
                across desktop, web and mobile.
            </p>
            <div className="flex flex-wrap gap-3 mt-8">
                <a
                    href={LIVE_ACCOUNT_URL}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="platform-hero-cta"
                    className="btn-primary"
                >
                    Open Live Account <ArrowUpRight size={18} />
                </a>
                <a
                    href="#downloads"
                    className="btn-secondary"
                    data-testid="platform-hero-downloads"
                >
                    Download MT5
                </a>
            </div>
        </motion.div>
    );
}

export default function PlatformHero() {
    return (
        <section className="relative pt-36 pb-20 overflow-hidden">
            <div className="absolute inset-0 -z-10 xpo-grid-bg opacity-40" />
            <div className="absolute -top-20 right-0 w-[600px] h-[600px] xpo-glow-mint blur-3xl -z-10" />

            <div className="xpo-container">
                <div className="grid lg:grid-cols-12 gap-12 items-center">
                    <PlatformHeroCopy />
                    <motion.img
                        variants={imageEnter}
                        initial="hidden"
                        animate="visible"
                        src={PLATFORM_IMG}
                        alt="MT5"
                        className="lg:col-span-5 rounded-2xl border border-white/10"
                    />
                </div>
            </div>
        </section>
    );
}
